import React, { memo, useState } from "react";
import Plyr from "plyr-react";
import "plyr-react/plyr.css";
import RawHTML from "./../../../component/RawHTML";
import AxiosClient from "../../../client/AxiosClient";
import {
  API_MARK_LESSON_AS_COMPLETE,
  API_TRACK_TIME,
} from "../../../ApiEndPoints";
import { useRef } from "react";
import { useEffect } from "react";

import "./../styles/ShowLesson.style.css";
import { FilledPrimaryBtnLink } from "../../../component/FilledBtn";
import ReactPlayer from "react-player";

function ShowLesson({ lesson, setReloadCourseContent }) {
  setReloadCourseContent = function () {};

  let host = lesson.host.toLowerCase();
  if (host === "self") {
    return (
      <ShowVideoLesson
        video_src={lesson.video_url}
        setReloadCourseContent={setReloadCourseContent}
        {...lesson}
      />
    );
  } else if (host === "pdf") {
    return (
      <ShowPdfLesson
        pdf_src={lesson.video_url}
        setReloadCourseContent={setReloadCourseContent}
        {...lesson}
      />
    );
  } else if (host === "audio") {
    return (
      <ShowAudioLesson
        audio_src={lesson.video_url}
        setReloadCourseContent={setReloadCourseContent}
        {...lesson}
      />
    );
  } else if (host == "link" || host == "url") {
    return (
      <ShowExternalLink
        link={lesson.video_url}
        setReloadCourseContent={setReloadCourseContent}
        {...lesson}
      />
    );
  } else if (host == "youtube") {
    return (
      <ShowYoutubeVideoLesson
        video_src={lesson.video_url}
        setReloadCourseContent={setReloadCourseContent}
        {...lesson}
      />
    );
  } else if (host == "google form") {
    return (
      <ShowGoogleForm
        link={lesson.video_url}
        setReloadCourseContent={setReloadCourseContent}
        {...lesson}
      />
    );
  } else {
    return <ShowQuizzLesson lesson={lesson} />;
  }
}

const ShowVideoLesson = memo(function ({
  video_src,
  course_id,
  id,
  setReloadCourseContent,
}) {
  console.log("ShowVideoLesson rendered");

  const markAsCompleted = () => {
    AxiosClient.post(API_MARK_LESSON_AS_COMPLETE, {
      course_id: course_id,
      lesson_id: id,
    })
      .then((response) => {
        setReloadCourseContent();
      })
      .catch((err) => {
        console.error("Getting error while marking lesson as complete", err);
      });
  };

  const [speed, setSpeed] = useState(1);

  return (
    <div className="show-lesson">
      <ReactPlayer
        url={video_src} // Self-hosted video URL
        controls
        width="100%"
        height="auto"
        onEnded={markAsCompleted}
        playbackRate={speed}
      />

      <select
        className="form-select"
        onChange={({ target }) => {
          setSpeed(target.value);
        }}
      >
        <option value="0.25">Speed X 0.25</option>
        <option value="0.5">Speed X 0.5</option>
        <option value="1" selected>
          Speed X 1
        </option>
        <option value="1.5">Speed X 1.5</option>
        <option value="2">Speed X 2</option>
        <option value="3">Speed X 3</option>
        <option value="4"> Speed X 4</option>
      </select>
    </div>
  );
});

const ShowPdfLesson = memo(function ({
  pdf_src,
  course_id,
  id,
  setReloadCourseContent,
}) {
  console.log("ShowPdfLesson rendered");
  const markAsCompleted = () => {
    AxiosClient.post(API_MARK_LESSON_AS_COMPLETE, {
      course_id: course_id,
      lesson_id: id,
    })
      .then((response) => {
        setReloadCourseContent();
      })
      .catch((err) => {
        console.error("Getting error while marking lesson as complete", err);
      });
  };

  useEffect(() => {
    markAsCompleted();
  }, []);

  return (
    <>
      <TrackTimeOfLesson course_id={course_id} lesson_id={id} />
      <div className="show-pdf-lesson p-3">
        <embed src={pdf_src} width="100%" height="600" type="application/pdf" />
        <p>
          <a href={pdf_src} target="_blank">
            Download File
          </a>
        </p>
      </div>
    </>
  );
});

const ShowAudioLesson = memo(function ({
  audio_src,
  course_id,
  id,
  setReloadCourseContent,
}) {
  console.log("ShowAudioLesson rendered");
  const markAsCompleted = () => {
    AxiosClient.post(API_MARK_LESSON_AS_COMPLETE, {
      course_id: course_id,
      lesson_id: id,
    })
      .then((response) => {
        setReloadCourseContent();
      })
      .catch((err) => {
        console.error("Getting error while marking lesson as complete", err);
      });
  };

  useEffect(() => {
    markAsCompleted();
  }, []);

  return (
    <>
      <TrackTimeOfLesson course_id={course_id} lesson_id={id} />
      <div className="show-audio-lesson d-flex align-items-center justify-content-center p-3">
        <audio controls>
          <source src={audio_src} />
          Your browser does not support the audio element.
        </audio>
      </div>
    </>
  );
});

const ShowExternalLink = memo(function ({
  link,
  course_id,
  id,
  setReloadCourseContent,
}) {
  console.log("ShowExternalLink rendered");

  const markAsCompleted = () => {
    AxiosClient.post(API_MARK_LESSON_AS_COMPLETE, {
      course_id: course_id,
      lesson_id: id,
    })
      .then((response) => {
        setReloadCourseContent();
      })
      .catch((err) => {
        console.error("Getting error while marking lesson as complete", err);
      });
  };

  useEffect(() => {
    markAsCompleted();
  }, []);

  return (
    <>
      <TrackTimeOfLesson course_id={course_id} lesson_id={id} />
      <div className="show-external-link p-3 py-5 ">
        <h5>Please open below link to get this lesson contents</h5>
        <a href={link} target="_blank">
          Visit
        </a>
      </div>
    </>
  );
});

const ShowQuizzLesson = memo(function ({ lesson }) {
  console.log("ShowQuizzLesson rendered");

  let quizz =
    typeof lesson.quiz_for_api[0] != "undefined"
      ? lesson.quiz_for_api[0]
      : lesson.quiz_for_api;

  return (
    <div className="show-quizz-lesson py-5 p-3">
      <span className="bg-primary p-2 text-white rounded-1 mb-2 d-inline-block">
        Quizz
      </span>
      <h5>{quizz.title}</h5>

      <p className="lead">Note: Only two attemps are allowed</p>

      {console.log(lesson.student_quizz_result)}

      {lesson?.student_quizz_result.length < 2 && (
        <FilledPrimaryBtnLink
          label={"Start the Quizz"}
          link={`/my-course/take-quizz/${lesson.course_id}/${quizz.id}`}
        />
      )}

      {lesson?.student_quizz_result?.length > 0 && (
        <div className="table-responsive mt-4">
          <table className="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th className="vertical-middle">Attempt</th>
                <th className="vertical-middle">Time taken</th>
                <th className="text-center vertical-middle"> Status (%)</th>
                <th className="text-center vertical-middle">Show result</th>
              </tr>
            </thead>
            <tbody>
              {lesson?.student_quizz_result.map((item, index) => {
                return (
                  <tr>
                    <td className="vertical-middle">{index + 1}</td>
                    <td className="vertical-middle">
                      {item.finish_minute} Min.
                    </td>
                    <td className="text-center vertical-middle">
                      {item.is_passed ? (
                        <span className="bg-success text-white p-2 rounded-2 me-1">
                          Pass
                        </span>
                      ) : (
                        <span className="bg-danger text-white p-1 rounded-2 me-1">
                          Failed
                        </span>
                      )}
                      {item.percentage} %
                    </td>
                    <td className="vertical-middle text-center">
                      <FilledPrimaryBtnLink
                        label={"Show result"}
                        link={`/my-course/quizz-result/${lesson.course_id}/${lesson.completed.id}/${item.id}`}
                        classes={`mt-0 btn-sm px-2 py-1 `}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* <p className="lead">
        {lesson.completed == null ? (
          <>
            <strong>Instructions: </strong>
            <RawHTML
              rawHTML={`<p className="lead">${quizz.instruction} </p>`}
            ></RawHTML>
          </>
        ) : (
          <div>
            <strong>You have already taken this quizz</strong>
          </div>
        )}

        {lesson.completed == null ? (
          <FilledPrimaryBtnLink
            label={"Start the Quizz"}
            link={`/my-course/take-quizz/${lesson.course_id}/${quizz.id}`}
          />
        ) : (
          <FilledPrimaryBtnLink
            label={"Show result"}
            link={`/my-course/quizz-result/${lesson.course_id}/${lesson.completed.id}`}
            classes={`mt-3`}
          />
        )}
      </p> */}
    </div>
  );
});

const ShowYoutubeVideoLesson = memo(function ({ video_src, course_id, id }) {
  console.log("ShowYoutubeVideoLesson rendered");
  const markAsCompleted = () => {
    AxiosClient.post(API_MARK_LESSON_AS_COMPLETE, {
      course_id: course_id,
      lesson_id: id,
    })
      .then((response) => {})
      .catch((err) => {
        console.error("Getting error while marking lesson as complete", err);
      });
  };

  return (
    <>
      <TrackTimeOfLesson course_id={course_id} lesson_id={id} />
      <div className="show-lesson">
        <ReactPlayer
          url={video_src} // Self-hosted video URL
          controls
          width="100%"
          height="500px"
          onEnded={markAsCompleted}
          config={{
            youtube: {
              playerVars: {
                modestbranding: 0, // Removes YouTube logo from controls
                rel: 0, // Disables related videos at the end
                showinfo: 0, // Hides title info (deprecated)
                fs: 1, // Allows fullscreen
              },
            },
          }}
        />
      </div>
    </>
  );
});

const ShowGoogleForm = memo(function ({
  link,
  course_id,
  id,
  setReloadCourseContent,
}) {
  console.log("ShowGoogleForm rendered");
  const markAsCompleted = () => {
    AxiosClient.post(API_MARK_LESSON_AS_COMPLETE, {
      course_id: course_id,
      lesson_id: id,
    })
      .then((response) => {
        setReloadCourseContent();
      })
      .catch((err) => {
        console.error("Getting error while marking lesson as complete", err);
      });
  };

  useEffect(() => {
    markAsCompleted();
  }, []);

  return (
    <>
      <TrackTimeOfLesson course_id={course_id} lesson_id={id} />
      <div className="show-external-link p-3 py-5 ">
        <h5>Please open below link to open form</h5>
        <a href={link} target="_blank">
          Open form
        </a>
      </div>
    </>
  );
});

const TrackTimeOfLesson = memo(function TrackTimeOfLesson({
  course_id,
  lesson_id,
}) {
  console.log("TrackTimeOfLesson rendered");

  useEffect(() => {
    let timer;

    const tick = () => {
      AxiosClient.post(API_TRACK_TIME, { course_id, lesson_id })
        .then(() => console.log("time sent"))
        .catch((err) =>
          console.error("Error while marking lesson as complete", err)
        )
        .finally(() => {
          // schedule again
          timer = setTimeout(tick, 60 * 1000);
        });
    };

    // start loop
    tick();

    return () => clearTimeout(timer);
  }, [course_id, lesson_id]);

  return null;
});

export default memo(ShowLesson);
